<template>
  <div class="carrier-select" v-clickoutside="handleCloseDialog">
    <div class="carrier-label"  @click="showDialog = !showDialog">Carriers</div>
    <span class="carrier-line"  @click="showDialog = !showDialog"></span>
    <div :class="['carrier-input', value.length && !showDialog && !(value.length === sourceList.length || allCheckbox) ? 'hasValue' : '']"  @click="showDialog = !showDialog">
      <template v-if="value.length !== sourceList.length">
        <template v-for="(item, index) in showList">
          <div v-if="index < number" class="carrier-item"  :key="index">
            <span class="carrier-name" :style="coputedStyle(item)">{{item.companyName}}</span>
            <span class="carrier-gap" v-if="index !== showList.length - 1">,</span>
          </div>
        </template>
      </template>
      <template v-if="value.length === sourceList.length || allCheckbox">
        <div class="carrier-item"><span class="carrier-name">All Carriers</span></div>
      </template>
      <template v-if="!value.length && !allCheckbox">
        <div class="carrier-item"><span class="carrier-name">--</span></div>
      </template>
      <span class="carrier-hide-numer" v-if="showList.length - number > 0 && value.length !== sourceList.length">+{{showList.length - number}}</span>
      <svg-icon :class="['svg-down', 'svg-ic',showDialog ? 'carrier-show-dialg' : '']" name="Drop-Down"></svg-icon>
      <svg-icon class="svg-close svg-ic" name="Wrong" @click.native.stop="clearCarrier"></svg-icon>
    </div>
    <div class="carrier-dialog" v-if="showDialog">
      <div class="carrier-dialog-content">
        <div :class="['carrier-dialog-item', allCheckbox ? 'dialog-item-check' : '' ]" @click="clickCheckboxAll($event)">
          <el-checkbox class="tp-checkbox-16" :value="allCheckbox"></el-checkbox>
          <span class="carrier-dialog-name">All Carriers</span>
        </div>
        <div :class="['carrier-dialog-item', value.includes(item.fleetCompanyId) && !allCheckbox ? 'dialog-item-check' : '']" v-for="(item, index) in sourceList" :key="index" @click="clickItem(item, $event)">
          <el-checkbox class="tp-checkbox-16" :value="value.includes(item.fleetCompanyId) && !allCheckbox"></el-checkbox>
          <span class="carrier-dialog-name">{{item.companyName}}</span>
        </div>
      </div>
    </div>
    <div v-if="showComputedWidthDiv" class="showComputedWidthDiv">
      <div :ref="'ref' + index" v-for="(item, index) in sourceList" :key=index>{{item.companyName}}</div>
    </div>
  </div>
</template>
<script>
import Clickoutside from '@/tools/clickoutside'
import { getCarrierList } from '@/api/dashboard'
import throttle from 'lodash/throttle'
export default {
  name: 'common-carrier-select',
  directives: { Clickoutside },
  data() {
    return {
      throttle: throttle,
      allCheckbox: false,
      showDialog: false,
      pageList: [],
      showComputedWidthDiv: false,
      sourceList: [],
      number: 0,
      inputWidth: 200,
    }
  },
  model: {
    event: 'changeValue',
    prop: 'value'
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    list: {
      type: Array
    }
  },
  computed: {
    showList() {
      return this.sourceList.filter(res => this.value.includes(res.fleetCompanyId))
    }
  },
  watch: {
    value: {
      handler() {
        this.$nextTick(() => {
           this.$emit('change', this.value)
        })
      },
      deep: true
    },
    list: {
      handler(val) {
        if (val) {
          this.sourceList = JSON.parse(JSON.stringify(this.list))
          this.showComputedWidthDiv = true
          this.clickItemAll()
          this.allCheckbox = true
          this.$nextTick(() => {
            this.computedWidth()
          })
        }
      },
      immediate: true,
      deep: true
    },
    pageList: {
      handler(val) {
        if (!this.list) {
          this.sourceList = val
        } else {
          this.sourceList = JSON.parse(JSON.stringify(this.list))
        }
        this.showComputedWidthDiv = true
        this.clickItemAll()
        this.allCheckbox = true
        this.$emit('getCarrierFinish')
        this.$nextTick(() => {
          this.computedWidth()
        })
      },
      // immediate: true,
      deep: true
    }
  },
  created() {
  },
  mounted() {
    if (!this.list){
      this.getCarrierList()
    }
  },  
  methods: {
    clickCheckboxAll(event) {
      if (event.target.tagName !== 'SPAN') {
        return
      }
      if (!this.sourceList.length) {return}
      this.allCheckbox = !this.allCheckbox
      let value = this.sourceList.map(res => res.fleetCompanyId)
      if (this.value.length !== value.length) {
        this.$emit('changeValue', value)
      }
      this.$nextTick(() => {
        this.coputedNumber()
      })
    },
    clickItemAll() {
      if (this.value.length === this.sourceList.length) {
        let value = []
        this.$emit('changeValue', value)
        this.$nextTick(() => {
          this.coputedNumber()
        })
      } else {
        let value = this.sourceList.map(res => res.fleetCompanyId)
        this.$emit('changeValue', value)
        this.$nextTick(() => {
          this.coputedNumber()
        })
      }
    },
    handleCloseDialog() {
      this.showDialog = false
    },
    clickItem(data, event) {
      if (event.target.tagName !== 'SPAN') {
        return
      }
      let value = JSON.parse(JSON.stringify(this.value || []))
      if (value.includes(data.fleetCompanyId)) {
        value.splice(value.indexOf(data.fleetCompanyId), 1)
      } else {
        value.push(data.fleetCompanyId)
      }
      if (this.allCheckbox) {
        value = [data.fleetCompanyId]
      }
      if (value.length === 0) {
        this.allCheckbox = true
        value = this.sourceList.map(res => res.fleetCompanyId)
      } else {
        this.allCheckbox = false
      }
      this.$emit('changeValue', value)
      this.$nextTick(() => {
        this.coputedNumber()
      })
    },
    clearCarrier() {
      this.allCheckbox = true
      let value = this.sourceList.map(res => res.fleetCompanyId)
      if (this.value.length !== value.length) {
         this.$emit('changeValue', value)
      }
    },
    coputedStyle(data) {
      if (data.width < 100) {
        return `width: auto`
      } else {
        return `width: ${data.width}px`
      }
    },
    getCarrierList() {
      getCarrierList().then(res => {
        this.pageList = res.res.data.data
      })
    },
    computedWidth() {
      this.sourceList.forEach((item, index) => {
        item.width = Math.min(this.$refs[`ref${index}`][0].clientWidth + 1, 100)
      });
      this.showComputedWidthDiv = false
    },
    coputedNumber() {
      this.number = this.showList.length
      let fnWidth = 0
      let computedWill = false
      this.showList.forEach((item, index) => {
        fnWidth += item.width + 6
        if(fnWidth > this.inputWidth && !computedWill) {
          this.number = index
          computedWill = true
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.carrier-select{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  cursor: pointer;
}
.carrier-label{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #7F8596;
  padding-right: 8px;
}
.carrier-line{
  background: #DADCE1;
  height: 16px;
  width: 1px;
  margin-right: 8px;
}
.carrier-input{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.carrier-item{
  display: flex;
}
.carrier-name{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #4066D4;
}
.carrier-dialog{
  position: absolute;
  top: 22px;
  left: 71px;
  background: #fff;
  z-index: 100;
  padding: 8px;
  padding-right: 4px;
  border: 1px solid #E1E3E9;
  box-shadow: 0px 4px 10px -2px rgba(16, 24, 40, 0.1), 0px 0px 4px -2px rgba(16, 24, 40, 0.05);
  border-radius: 4px;
  overflow: hidden;
}
.carrier-hide-numer{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #4066D4;
}
.carrier-gap{
  width: 6px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #4066D4;
  text-align: left;
}
.showComputedWidthDiv{
  width: 1px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  div{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    color: #000;
  }
}
.carrier-dialog-item{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  cursor: pointer;
}
.carrier-dialog-name{
  margin-left: 8px;
  width: 140px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.carrier-show-dialg{
  transform: rotate(180deg);
}
.carrier-dialog-content{
  max-height: 252px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
    height: 100%;
    display: block;
    background: #E7EBF3;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    box-shadow: 8px 0 0 rgba(#FFF, 0.3) inset;
    border-width: 2px 2px;
    border-style: solid;
    border-color: #E7EBF3;

    &:hover {
      box-shadow: 4px 0 0 rgba(#FFF, 0.5) inset;
    }
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
}
.svg-close{
  display: none;
}
.hasValue{
  &:hover{
    .svg-down{
      display: none;
    }
    .svg-close{
      display: block;
    }
  }
}
.svg-ic{
  height: 16px;
  width: 16px;
  margin-left: 2px;
}
.dialog-item-check{
  .carrier-dialog-name{
    color: #4066D4;
  }
}
</style>